import { Component, OnDestroy, OnInit } from '@angular/core';
import { SagaSettingsService } from '@services/settings';
import { HeaderTitleProviderService, IHeaderTitle } from '../../services/header-title-provider/header-title-provider.service';

@Component({
  selector: 'app-header-title',
  templateUrl: './header-title.component.html',
  styleUrls: ['./header-title.component.scss']
})
export class HeaderTitleComponent implements OnInit, OnDestroy {
  unitStatusFontSize: string = null;
  headerTitle: IHeaderTitle;

  constructor(private settingsService: SagaSettingsService, private headerTitleProvider: HeaderTitleProviderService) {}

  ngOnInit() {
    this.unitStatusFontSize = this.settingsService.getValue('SagaMobileWebClient.HeaderStatusTextSize');

    this.headerTitleProvider.setup();
    this.headerTitle = this.headerTitleProvider.getHeaderTitle();
  }

  ngOnDestroy() {
    this.headerTitleProvider.cleanup();
  }
}
